import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'szz-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  isOpen = input<boolean>(false);
  /** Shown below the lg breakpoint, where the header's user menu (and the name in it) is hidden. */
  userName = input<string>('');
  isAdmin = input<boolean>(false);
  logout = output<void>();

  onLogout(): void {
    this.logout.emit();
  }
}
